import React, { useContext } from "react";
import { UploadCsvMenuContextValue } from "../../../types/menu/database/uploadCsvMenu";

export const UploadCsvMenuContext =
  React.createContext<UploadCsvMenuContextValue | null>(null);

export const useUploadCsvMenuContext = () => {
  const ctx = useContext(UploadCsvMenuContext);
  if (!ctx) {
    throw new Error("Must Call within UploadCsvMenuProvider");
  }
  return ctx;
};
